import faqs from '../seo/faqs.json'

export interface FaqItem {
  q: string
  a: string
}

const BY_PATH = faqs as unknown as Record<string, FaqItem[]>

/** FAQ entries for a public route. The FAQPage JSON-LD is built from the same
 *  data in scripts/prerender.mjs, so visible text and structured data agree. */
export function faqFor(path: string): FaqItem[] {
  return BY_PATH[path] ?? []
}

/**
 * Plain (non-collapsing) FAQ list. Answers stay in the markup so crawlers and
 * non-JS clients read them without interaction.
 */
export function FaqSection({ path, heading = 'Frequently asked questions' }: { path: string; heading?: string }) {
  const items = faqFor(path)
  if (items.length === 0) return null

  return (
    <section className="py-16 sm:py-24 px-4">
      <div className="max-w-3xl mx-auto">
        <h2 className="text-2xl sm:text-3xl font-bold text-center mb-10">{heading}</h2>
        <dl className="space-y-8">
          {items.map((item) => (
            <div key={item.q}>
              <dt className="text-base sm:text-lg font-semibold text-gray-900 dark:text-white mb-2">{item.q}</dt>
              <dd className="text-gray-600 dark:text-gray-400 leading-relaxed">{item.a}</dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  )
}
